import React from 'react'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
    container: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '8px 0',
    },
    image: {
        width: '100%',
        maxWidth: 360,
        borderRadius: 12,
        display: 'block',
        '@media (min-width: 600px) and (orientation: landscape)': {
            maxWidth: '60%',
            maxHeight: '28vh',
            objectFit: 'contain',
        },
        '@media (max-width: 599px)': {
            maxWidth: '100%',
            maxHeight: '30vh',
            objectFit: 'contain',
        },
    },
}))

/**
 * ImageInteraction — displays an image (interactiveElementType === 7).
 * Non-scored; auto-completes immediately.
 */
const ImageInteraction = ({ testOption, imageMap, onComplete }) => {
    const classes = useStyles()

    const imageBlobUrl = testOption.imageUrl
        ? imageMap[testOption.imageUrl]
        : null

    // Auto-complete immediately since this is just a display element
    React.useEffect(() => {
        if (onComplete) {
            onComplete({
                testOptionId: testOption.testOptionId,
                answers: [],
            })
        }
    }, [])

    if (!imageBlobUrl) return null

    return (
        <div className={classes.container}>
            <img src={imageBlobUrl} alt="" className={classes.image} />
        </div>
    )
}

export default ImageInteraction
